import { TuiDay } from "@taiga-ui/cdk";

export const convertDateConnectorFormat = (
  dateFormat: string,
  day: number,
  month: number,
  year: number
): string => {
  const date = new Date(year, month, day);

  if (
    date.getDate() !== day ||
    date.getMonth() !== month ||
    date.getFullYear() !== year
  ) {
    throw new Error(
      `The Date Provided with Day:${day}, Month:${month} & Year:${year} is in invalid format.`
    );
  }

  const DEFAULT_DATE_FORMAT = "DD-MM-YYYY";

  dateFormat = dateFormat || DEFAULT_DATE_FORMAT;

  const formattedDay = String(day).padStart(2, "0");
  const formattedMonth = String(month + 1).padStart(2, "0");
  const formattedYear = dateFormat.includes("YYYY")
    ? String(year)
    : String(year % 100);

  return dateFormat
    .replace("DD", formattedDay)
    .replace("MM", formattedMonth)
    .replace(/YYYY|YY/, formattedYear);
};

export const convertStandardDateToStringFormat = (
  date: Date,
  dateFormat: string
): string => {
  let formattedDate: string = null;
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  formattedDate = convertDateConnectorFormat(dateFormat, day, month, year);

  return formattedDate;
};

export const convertKwikUIDateFormatToStringFormat = (
  date: TuiDay,
  dateFormat: string
): string => {
  let formattedDate: string = null;
  const { year } = date;
  const { month } = date;
  const { day } = date;

  formattedDate = convertDateConnectorFormat(dateFormat, day, month, year);

  return formattedDate;
};

export const convertStringDateToKwikUIFormat = (date: string): TuiDay => {
  const splitDate = date.split("-");
  const tuiDay = new TuiDay(
    Number(splitDate[2]), // Year
    Number(splitDate[1]) - 1, // Month, Why '-1' => Because Taiga-UI Required It, So...
    Number(splitDate[0]) // Day
  );

  return tuiDay;
};
